import React, { useRef, useState } from 'react';
import axios from 'axios';
import { Link2 } from 'lucide-react';
import { Button } from '../ui/button';
import { useAuth, formatApiErrorDetail } from '../../auth';

export const KickLinkButton = ({ enabled = true, testId = 'kick-connect-button' }) => {
  const { authHeader } = useAuth();
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const pending = useRef(false);
  const start = async () => {
    if (pending.current) return;
    pending.current = true; setBusy(true); setError('');
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/kick/oauth/start`, {}, { headers: authHeader(), withCredentials: true, timeout: 20000 });
      window.location.assign(data.authorization_url);
    } catch (failure) {
      setError(formatApiErrorDetail(failure.response?.data?.detail || 'Could not open Kick. Please try again.'));
      pending.current = false; setBusy(false);
    }
  };
  return <div className="kick-link-control"><Button className="connection-action" disabled={!enabled || busy} onClick={start} data-testid={testId}><Link2 size={16} aria-hidden="true" data-testid={`${testId}-icon`} />{busy ? 'Opening Kick…' : 'Connect Kick'}</Button>
    {error && <p className="settings-error" role="alert" data-testid={`${testId}-error`}>{error}</p>}
  </div>;
};